<div (click)="sendUserData()" class="user-container" [ngStyle]="config.cssStyle"
    [style.--scale-dpad]="1.03" [attr.dpad]="DpadZoneType.MAIN" [attr.x-dpad]="dpadX" [attr.y-dpad]="dpadY">
    <div class="user-infor user-infor-hover" [attr.data-fullname]="fullName">
        <div class="row">
            <div class="top-row">
                <label class="lbl-infor romanji" [ngStyle]="labelCssStyle">{{ upperCaseText(data.romanjiFamily) + ' ' +
                    upperCaseText(data.romanjiGiven) }}</label>
            </div>
            <div class="bottom-row">
                <label class="lbl-infor kanji" [ngStyle]="labelCssStyle">{{(data.family || '') +' '+ (data.given ||
                    '')}}</label>
            </div>
        </div>
        <div class="tooltip">
            <div class="romanji">{{upperCaseText(data.romanjiFamily) + ' ' + upperCaseText(data.romanjiGiven) }}</div>
            <div class="kanji">{{(data.family || '') +' '+ (data.given || '')}}</div>
        </div>
    </div>

    <div class="avatar">
        <div class="avatar-square">
            <img [id]="'avatar-' + (data.daicd || '')" class="user-icon" [ngClass]="data.sex == 1 ? 'men' : 'wman'" [src]="data.face_img" (error)="onAvatarError()" />
            <span class="avatar-spinner" *ngIf="avatarStatus === 'loading'" aria-hidden="true"></span>
        </div>
    </div>
    <div *ngIf="isBathScreen" class="short-term-badge" [class.visible]="isShortTerm">
        <span>短</span>
    </div>
</div>